export const i18n = {
	spotlightHeadline: {
		id: 'reactions.spotlight.headline',
		defaultMessage: 'Share your reaction',
		description: 'Headline for the reactions spotlight onboarding',
	},
	spotlightBody: {
		id: 'reactions.spotlight.body',
		defaultMessage: 'Leave a quick reaction to let your teammates know what you think!',
		description: 'Body text for the reactions spotlight onboarding',
	},
	spotlightDone: {
		id: 'reactions.spotlight.done',
		defaultMessage: 'OK',
		description: 'Done button text for the reactions spotlight onboarding',
	},
};

